export class FingerLocalization {
  static fingerName(name: string | undefined): string {
    switch (name) {
      case 'little':
        return 'мизинца';
      case 'ring':
        return 'безымянного пальца';
      case 'middle':
        return 'среднего пальца';
      case 'index':
        return 'указательного пальца';
      case 'thumb':
        return 'большого пальца';
      default:
        return '';
    }
  }

  static handName(name: string | undefined): string {
    switch (name) {
      case 'left':
        return 'левой';
      case 'right':
        return 'правой';
      default:
        return '';
    }
  }
}
